<ng-container *ngIf="permissions.viewAuditTrail">
  <button mat-icon-button [matMenuTriggerFor]="actionMenu" class="xs">
    <mat-icon class="kabob xs" iconPositionEnd>more_vert</mat-icon>
  </button>
  <mat-menu #actionMenu="matMenu">
    <button *ngIf="permissions.viewAuditTrail" mat-menu-item (click)="viewAuditTrail()">
      {{ (field ? 'queriesDialog.actions.viewAttributeAuditTrail' : 'queriesDialog.actions.viewAuditTrail') | translate }}
    </button>
  </mat-menu>
</ng-container>
